import { api, unwrap, type ResponseEnvelope } from '@saas-kit/lib';

export interface ApiKeyRecord {
  id: string;
  tenant_id: string;
  name: string;
  prefix: string;
  scopes: string[];
  last_used_at: string | null;
  revoked_at: string | null;
}

export interface ApiKeyCreated {
  api_key: ApiKeyRecord;
  secret: string;
}

export interface PermissionScope {
  key: string;
  module: string;
  description: string;
  assignable: boolean;
}

interface ListEnvelope<T> {
  items: T[];
}

export async function listApiKeys(): Promise<ApiKeyRecord[]> {
  const data = await unwrap<ListEnvelope<ApiKeyRecord>>(api.get('/api-keys'));
  return data.items;
}

export async function createApiKey(input: {
  name: string;
  scopes: string[];
}): Promise<ApiKeyCreated> {
  return unwrap<ApiKeyCreated>(api.post('/api-keys', input));
}

export async function revokeApiKey(apiKeyId: string): Promise<void> {
  await unwrap(
    api.post<ResponseEnvelope<unknown>>(`/api-keys/${apiKeyId}/revoke`),
  );
}

export async function listApiKeyScopes(): Promise<PermissionScope[]> {
  const data = await unwrap<ListEnvelope<PermissionScope>>(api.get('/permissions'));
  return data.items;
}
